import { Injectable } from "@angular/core";
import { TokenService } from "../tokenManagement/token.service";
import { Httpheaders } from "../model/requests/httpheaders";
import * as cryptoJS from "crypto-js";

@Injectable()
export class HttpheaderService {
  public httpheader = new Httpheaders();

  constructor(private tokenService: TokenService) {}
  //for full headers
  getTokens() {
    let ctrlT = this.tokenService.getAccessToken();
    let usrT = this.tokenService.getUserToken();
    let cid = this.tokenService.getclientID();
    let uAthTok = this.tokenService.getUserAuthToken();
    this.httpheader.accessToken = ctrlT["accessToken"];
    this.httpheader.accessKey = ctrlT["accessSecret"];
    this.httpheader.X_USER_TOKEN = usrT["secretKey"];
    this.httpheader.X_TOKEN = ctrlT["accessToken"];
    this.httpheader.X_AUTH_TOKEN = uAthTok["secretKey"];
    this.httpheader.X_CLIENT_ID = cid["clientID"];
  }

  //for specific headers
  getCtrlTokens() {
    let ctrlT = this.tokenService.getAccessToken();
    this.httpheader.accessToken = ctrlT["accessToken"];
    this.httpheader.accessKey = ctrlT["accessSecret"];
  }

  encodeUrl(url) {
    let encodedUrl = encodeURIComponent(url);
    return encodedUrl;
  }

  //for full headers.
  setSignature(httpMethod: string, url) {
    this.getTokens();
    this.httpheader.Nonce = "UniCollect";
    this.httpheader.Timestamp = Date.now().toString();
    this.httpheader.signature = cryptoJS.SHA512(
      this.httpheader.accessToken +
        "&&" +
        this.httpheader.accessKey +
        "&&" +
        this.httpheader.Timestamp +
        "&&" +
        this.httpheader.Nonce +
        "&&" +
        httpMethod +
        "&&" +
        this.encodeUrl(url)
    );
    return this.httpheader.signature;
  }

  //for endpoints that do not require the full headers.. eg login
  setLoginHeader(httpMethod: string, url) {
    this.getCtrlTokens();
    this.httpheader.Nonce = "UniCollect";
    this.httpheader.Timestamp = Date.now().toString();
    this.httpheader.signature = cryptoJS.SHA512(
      this.httpheader.accessToken +
        "&&" +
        this.httpheader.accessKey +
        "&&" +
        this.httpheader.Timestamp +
        "&&" +
        this.httpheader.Nonce +
        "&&" +
        httpMethod +
        "&&" +
        this.encodeUrl(url)
    );
  }
}
